module.exports = __webpack_public_path__ + "static/media/doctor4.8051622f.png";